import hostIntegration from "./host";
import HostConfig from "./host/HostConfig";
import useStoreModal from "store/useStoreModal";
import useStorePlayer from "store/useStorePlayer";

export type AuthenticationMode = "register" | "login";

export default async function requestAuthentication(
    mode: AuthenticationMode = "register",
): Promise<void> {
    if(HostConfig.host === "web") {
        useStoreModal.getState().open("signup", { mode });

        return;
    }

    const result = await hostIntegration.requestPlayerAuthentication();

    // A new login is refreshed by the host auth listener. An account that was
    // already signed in does not emit that event, so it needs a direct refresh.
    if(result === "already-authenticated") {
        useStorePlayer.getState().refreshSession();
    }
}
